export const STATUS = {
  CANCELADO: "CANCELADO"
}



// WEBPACK FOOTER //
// ./src/scenes/SharedData/constants.js